import { isANumber } from "web/services/helpers"

export default function transform(field, value) {
  if (
    ["Number", "Area", "Money", "Length"].includes(field.kind) &&
    isANumber(value)
  ) {
    return Number.parseFloat(value)
  }

  return value
}
